import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-save-icon',
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.12"
      d="M4.16699 7.3C4.16699 7.01997 4.16699 6.87996 4.22149 6.773C4.26943 6.67892 4.34592 6.60243 4.44 6.5545C4.54695 6.5 4.68697 6.5 4.96699 6.5H8.36699C8.64702 6.5 8.78703 6.5 8.89399 6.5545C8.98807 6.60243 9.06456 6.67892 9.1125 6.773C9.16699 6.87996 9.16699 7.01997 9.16699 7.3V10.5H4.16699V7.3Z"
      fill="black"
    />
    <path
      d="M8.16699 4H4.96699C4.68697 4 4.54695 4 4.44 3.9455C4.34592 3.89757 4.26943 3.82108 4.22149 3.727C4.16699 3.62004 4.16699 3.48003 4.16699 3.2V1.5M9.16699 10.5V7.3C9.16699 7.01997 9.16699 6.87996 9.1125 6.773C9.06456 6.67892 8.98807 6.60243 8.89399 6.5545C8.78703 6.5 8.64702 6.5 8.36699 6.5H4.96699C4.68697 6.5 4.54695 6.5 4.44 6.5545C4.34592 6.60243 4.26943 6.67892 4.22149 6.773C4.16699 6.87996 4.16699 7.01997 4.16699 7.3V10.5M11.167 4.66274V8.1C11.167 8.94008 11.167 9.36012 11.0035 9.68099C10.8597 9.96323 10.6302 10.1927 10.348 10.3365C10.0271 10.5 9.60707 10.5 8.76699 10.5H4.56699C3.72691 10.5 3.30687 10.5 2.98601 10.3365C2.70376 10.1927 2.47429 9.96323 2.33048 9.68099C2.16699 9.36012 2.16699 8.94008 2.16699 8.1V3.9C2.16699 3.05992 2.16699 2.63988 2.33048 2.31901C2.47429 2.03677 2.70376 1.8073 2.98601 1.66349C3.30687 1.5 3.72691 1.5 4.56699 1.5H8.00425C8.24884 1.5 8.37114 1.5 8.48622 1.52763C8.58826 1.55213 8.6858 1.59253 8.77528 1.64736C8.87619 1.7092 8.96267 1.79568 9.13562 1.96863L10.6984 3.53137C10.8713 3.70432 10.9578 3.7908 11.0196 3.89172C11.0745 3.98119 11.1149 4.07873 11.1394 4.18077C11.167 4.29586 11.167 4.41815 11.167 4.66274Z"
      [attr.stroke]="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg> `,
})
export class SaveIcon extends BaseIconComponent {}
